export const SOURCE_AUTH_TYPES = {
  PEER_TO_PEER: 'peer_to_peer',
  EMAIL: 'email',
  COMPLIANCE: 'compliance_ai'
};
